import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import type { BankAccountType } from "@/company_admin/gql/__generated__/graphql"

export const accountingGroupSchema = yup.object({
	name: yup.string().required("グループ名は必須です"),
	displayName: yup.string().required("表示名は必須です"),
	bankCode: yup
		.string()
		.required("銀行コードは必須です")
		.matches(/^\d{4}$/, "銀行コードは4桁の数字で入力してください"),
	bankBranchCode: yup
		.string()
		.required("支店コードは必須です")
		.matches(/^\d{3}$/, "支店コードは3桁の数字で入力してください"),
	bankAccountType: yup
		.mixed<BankAccountType>()
		.oneOf(["ORDINARY", "CHECKING"])
		.required("口座種別は必須です"),
	bankAccountNumber: yup
		.string()
		.required("口座番号は必須です")
		.matches(/^\d+$/, "口座番号は数字で入力してください"),
	bankAccountHolderName: yup.string().required("口座名義は必須です"),
	billingEmails: yup
		.array()
		.of(yup.string().email("メールアドレスの形式が正しくありません").required())
		.min(1, "請求先メールアドレスは最低1件必要です")
		.required(),
})

export type AccountingGroupFormData = yup.InferType<
	typeof accountingGroupSchema
>

export const accountingGroupResolver = yupResolver(accountingGroupSchema)
